module.exports = __webpack_public_path__ + "static/media/cartIcon.c9d7c2a9.svg";